import PropTypes from 'prop-types';
import styles from './FJGenerateButton.module.less';
import CreditIcon from '../../../assets/svg/credit.svg?react';
import cionNew from '../../../assets/base64/cion-new.js';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJLoading from '../FJLoading/FJLoading';
import FJEllipsisLoading from '../FJEllipsisLoading/FJEllipsisLoading';
import FJConstant from '../../../constants/FJConstant';
import { useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJUsageDetailTwoContainer from '../../combineComponents/FJUsageDetail/container/FJUsageDetailContainerTwo';
import FJConfig from '../../../config/FJConfig';
import FJAppConstant from '../../../constants/FJAppConstant';

const FJGenerateButton = forwardRef((props, ref) => {
    const {
        id,
        className,
        onClick,
        isFree,
        useCredit,
        taskStatus,
        isProjectLoading,
        freeNumCreation,
        text,
        style,
        disabled = false,
        isShowUsageDetail = false,
        isHideCredit = false,
    } = props;

    const btnText = useMemo(() => {
        if (text) {
            return text;
        }
        if (taskStatus === FJConstant.START) {
            return 'start';
        } else if (taskStatus === FJConstant.WAITING) {
            return 'queuing';
        } else if (taskStatus === FJConstant.GENERATING) {
            return FJConfig.appType === FJAppConstant.VIDEO_REMOVE_BG ? 'removing' : 'generating';
        } else if (isFree) {
            return 'generate';
            // return 'free-creation';
        } else {
            return 'generate';
        }
    }, [taskStatus, isFree, text]);

    const isGenerating = FJUtil.isGeneratingStatus(taskStatus);
    const isLogin = FJUtil.isLogin();
    const isHideUseCredit = isProjectLoading || isFree;
    const creditText = useCredit > 0 ? `-${useCredit}` : 0;

    const usageDetailRef = useRef(null);

    const _renderTrigger = config => {
        return (
            <div className={styles.use_credit} onMouseMove={config?.onMouseMove} ref={config?.ref}>
                {/* <CreditIcon className={styles.credit_icon} /> */}
                <img src={cionNew} alt='credit' className={styles.credit_icon} />
                <span className={styles.use_credit_num}>{creditText}</span>
            </div>
        );
    };

    const _onClick = () => {
        usageDetailRef.current?.hide();
        onClick();
    };

    useImperativeHandle(ref, () => ({
        hideUsageDetail: () => {
            usageDetailRef.current?.hide();
        },
    }));

    return (
        <div
            className={classNames(
                styles.btn_box,
                isGenerating ? styles.generating : '',
                disabled ? styles.disabled : '',
                className,
            )}
            onClick={_onClick}
            style={style}
            id={id}
        >
            <div className={styles.text_box}>
                {isProjectLoading ? (
                    <FJLoading />
                ) : (
                    <>
                        <span className={styles.btn_text}>{FJLocalStore._(btnText)}</span>
                        {isGenerating && <FJEllipsisLoading />}
                        {!isHideCredit && isFree && isLogin && (
                            <span className={styles.free_creation}>
                                {freeNumCreation === 1
                                    ? FJLocalStore._('free-trie-left')
                                    : FJLocalStore._('free-tries-left').replace('xxx', freeNumCreation)}
                            </span>
                        )}

                        {!isHideCredit &&
                            !isHideUseCredit &&
                            isLogin &&
                            (isShowUsageDetail ? (
                                <FJUsageDetailTwoContainer ref={usageDetailRef} renderTrigger={_renderTrigger} />
                            ) : (
                                _renderTrigger()
                            ))}
                    </>
                )}
                <div className={styles.background_hover}></div>
            </div>
        </div>
    );
});

FJGenerateButton.displayName = 'FJGenerateButton';
FJGenerateButton.propTypes = {
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    useCredit: PropTypes.number,
    isFree: PropTypes.bool,
    className: PropTypes.string,
    taskStatus: PropTypes.string,
    isProjectLoading: PropTypes.bool,
    freeNumCreation: PropTypes.number,
    disabled: PropTypes.bool,
};
export default FJGenerateButton;
